var render, staticRenderFns
import script from "./VStyle.vue?vue&type=script&lang=js&"
export * from "./VStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "www/vues/common/controls/VStyle.vue"
export default component.exports